module.exports = __webpack_public_path__ + "ec60d83c6d35e42cc33373601f7df0cf.pdf";